import { IState } from "@/interfaces/IState";
import { IEvaluation } from "@/interfaces/evaluation/IEvaluation";
import { IQuiz } from "@/interfaces/quiz/IQuiz";
import axios from "axios";

export const evaluation = {
    state: {
        evaluation: {},
        evaluationDetail: {},
        savingLoading: false,
        evaluations: [],
        error: 0,
        evaluationUrl : process.env.VUE_APP_ROMA_EVALUATION_URL,
        pollUrl : process.env.VUE_APP_ROMA_POLL_URL,
    },
    mutations: {
        FETCH_EVALUATIONS: (state: IEvaluation, payload: any) => {
            state.evaluations = payload;
        },
        FILTER_EVALUATIONS: (state: IEvaluation, payload: any) => {
            state.evaluations = payload;
        },
        SAVE_EVALUATION: (state: IEvaluation, payload: any) => {
            state.evaluation = payload;
        },
        UPDATE_EVALUATION: (state: IEvaluation, payload: any) => {
            state.evaluation = payload;
        },
        SET_EVALUATION: (state: IEvaluation, payload: any) => {
            state.evaluation = payload;
        },
        SET_ERROR: (state: IState, payload: any) => {
            state.error = payload;
        },
        SET_EVALUATION_DETAIL: (state: IEvaluation, payload: any) => {
            state.evaluationDetail = payload;
        },
        SAVING_LOADING: (state: IState, payload: any) => {
            state.savingLoading = payload;
        },
        DETAILS_EVALUATION: (state: IEvaluation, payload: any) => {
            state.evaluationDetail = payload;
        },
        SET_QUESTIONS(state: IQuiz, payload: any) {
            state.questions = payload;
        },
    },
    actions: {
        async setEvaluation(context: any, payload: any) {
            context.commit('SAVING_LOADING', true);
            const { idInstitucion, idPersona, idMedicionAsignada, idPeriodo } = payload;
            return await axios.get(`${axios.defaults.baseURL}evaluation/detail?idInstitucion=${idInstitucion}&idMedicionAsignada=${idMedicionAsignada}&idPersona=${idPersona}&idPeriodo=${idPeriodo}`)
                .then((res) => {
                    context.commit('SET_EVALUATION', res.data);
                    context.commit('SAVING_LOADING', false);
                    return res;
                })
                .catch((error) => {
                    context.commit('SAVING_LOADING', false);
                    context.commit('SET_ERROR', 404);
                    console.error(error.response)
                    return error.response;
                });
        },
        async fetchEvaluations(context: any, payload: any) {
            context.commit('SAVING_LOADING', true);
            const { idInstitucion, idPersona, idPeriodo ,pageNumber, idEstado } = payload;
             return await axios.get(`${axios.defaults.baseURL}evaluation/all?idPeriodo=${idPeriodo}&idPersona=${idPersona}&pageNumber=${pageNumber}&idEstado=${idEstado}`)
            //return await axios.get(`${axios.defaults.baseURL}evaluation/all?idInstitucion=${idInstitucion}&idSection=11578&idMatricula=361936&idForma=20685`)
                .then((res) => {
                    context.commit('FETCH_EVALUATIONS', res.data);
                    context.commit('SAVING_LOADING', false);
                })
                .catch((err) => {
                    context.commit('SAVING_LOADING', false);
                    console.log(err)
                })
        },
        async filterEvaluations(context: any, payload: any) {
            context.commit('SAVING_LOADING', true);
            const { nombre, codigo, idAsignatura, idPersona, idPeriodo,idEstado ,pageNumber } = payload;
            return await axios.get(`${axios.defaults.baseURL}evaluation/all?nombre=${nombre}&codigo=${codigo}&idAsignatura=${idAsignatura}&idPeriodo=${idPeriodo}&idPersona=${idPersona}&pageNumber=${pageNumber}&idEstado=${idEstado}`)
                .then((res) => {
                    context.commit('FETCH_EVALUATIONS', res.data);
                    context.commit('SAVING_LOADING', false);
                })
                .catch((err) => {
                    context.commit('SET_ERROR', true);
                    console.log(err)
                });
        },
        async detailsEvaluation(context: any, payload: any) {
            context.commit('SAVING_LOADING', true);
            const { idForma, idInstitucion, idMedicionAsignada, idPeriodo, idPersona, idMatricula, idSeccion } = payload;
                return await axios.get(`${axios.defaults.baseURL}evaluation/detail?idMedicionAsignada=${idMedicionAsignada}`)
                .then((res) => {
                    console.log(res.data)
                    const { form } = res.data;
                    context.commit('DETAILS_EVALUATION', res.data);
                    context.commit('SET_QUESTIONS', form.questions);
                    context.commit('SAVING_LOADING', false);
                })
                .catch((err) => {
                    context.commit('SAVING_LOADING', false);
                    context.commit('SET_ERROR', true);
                    console.log(err)
                    console.error("Ha ocurrido un error en los detalles de la evaluacion, no hay datos para la consulta.")
                });
        },
        async saveEvaluation(context: any, payload: any) {
            context.commit('SAVING_LOADING', true);
            return await axios.post(`${axios.defaults.baseURL}/answersRegister`, payload)
                .then((res) => {
                    context.commit('SAVE_EVALUATION', res.data);
                    context.commit('SAVING_LOADING', false);
                })
                .catch((err) => {
                    context.commit('SAVING_LOADING', false);
                    context.commit('SET_ERROR', true);
                    console.log(err)
                });
        },
        async updateEvaluation(context: any, payload: any) {
            context.commit('SAVING_LOADING', true);
            const { assignedMeasurementId, enrollmentId, sectionId } = payload;
            return await axios.put(`${axios.defaults.baseURL}/evaluation/${assignedMeasurementId}/${enrollmentId}/${sectionId}`, payload)
                .then((res) => {
                    context.commit('UPDATE_EVALUATION', res.data);
                    context.commit('SAVING_LOADING', false);
                }).catch((error) => {
                    context.commit('SAVING_LOADING', false);
                    context.commit('SET_ERROR', true);
                    console.log(error)
                });
        }
    },
    getters: {
        getEvaluations(state: IEvaluation) {
            return state.evaluations;
        },
        getEvaluation(state: IEvaluation) {
            return state.evaluation;
        },
        getEvaluationDetail(state: IEvaluation) {
            return state.evaluationDetail;
        },
        getEvaluacionesUrlApi(state: IEvaluation) {
            return state.evaluationUrl;
        },
        getPollUrlApi(state: IEvaluation) {
            return state.pollUrl;
        },
        getLoading(state: IState){
            return state.savingLoading;
        }
    }
}